import { http } from '@/core/api/';

const baseURL = 'api/graduation';

export default {
  getChildCountSearchInitialFilterValues(properties) {
    return http.get('api/graduation/initfilters', {
      params: {
        ...properties,
      },
    });
  },
  getGraduationSearchData(properties) {
    return http.get('api/graduation', {
      params: {
        ...properties,
      },
    });
  },
  searchStudent(
    certificationId,
    studentSieIdOrRegistry,
    academicYearId,
    locationSchoolId
  ) {
    return http.get(
      `${baseURL}/${certificationId}/studentsearch/${studentSieIdOrRegistry}/${academicYearId}/${locationSchoolId}`
    );
  },
  addStudent(certificationId, studentSieId) {
    return http.post(`${baseURL}/addStudent`, {
      certificationId,
      studentSieId,
    });
  },
  getSchoolCustodian(locationSchoolId) {
    return http.get(`${baseURL}/schoolcustodians`, {
      params: {
        locationSchoolId,
      },
    });
  },
  assignCustodian(childCountCertificationStudentId, custodianUserId) {
    return http.put(`${baseURL}/assingcustodian`, {
      childCountCertificationStudentId,
      custodianUserId,
    });
  },
  include(childCountStudentCertificationId, academicYearId, locationSchoolId) {
    return http.post(`${baseURL}/include`, {
      childCountStudentCertificationId,
      academicYearId,
      locationSchoolId,
    });
  },
  removeManualStudent(childCountCertificationStudentId) {
    return http.delete(`${baseURL}/removestudent`, {
      params: {
        childCountCertificationStudentId,
      },
    });
  },
  async submitCertification(id) {
    return await http.put(`${baseURL}/submit/${id}`);
  },
  async loadStudentCertification(
    certificationId,
    isPrivateSchool,
    searchMode,
    filters = {}
  ) {
    return await http.get(`${baseURL}/studentcertifications`, {
      params: {
        certificationId: certificationId,
        StudentFilter: filters.sie,
        CustodianUserId: filters.teacher,
        alertFilterId: filters.alertFilterId,
        searchMode,
        isPrivateSchool,
      },
    });
  },
  async loadCertification(certificationId) {
    return await http.get(`${baseURL}/certifications`, {
      params: {
        certificationId: certificationId,
      },
    });
  },
  async loadStudentExcludeReasons() {
    return await http.get(`api/code/childcountexcludereasons`);
  },
  async getSchoolCustodianAsync(locationSchoolId) {
    return await http.get(`${baseURL}/schoolcustodians`, {
      params: {
        locationSchoolId,
      },
    });
  },
  markAllToChangeStatus(properties, flagSelection) {
    return http.post(
      `${baseURL}/markalltochangestatus/${flagSelection}`,
      properties
    );
  },
  markIndividualToChangeStatus(certificationId, flagSelection) {
    return http.post(
      `${baseURL}/changeflagselectionindividual/${certificationId}/${flagSelection}`
    );
  },
  existSelectionToChangeStatus(properties) {
    return http.post(`${baseURL}/existselectiontochangestatus`, properties);
  },
  approveMultiple(properties) {
    return http.post(`${baseURL}/approvemultiple/`, properties);
  },
  getProgress(acedemicYearId) {
    return http.get(`${baseURL}/progress/${acedemicYearId}`);
  },
  changePreviousStatus(id) {
    return http.post(`${baseURL}/changepreviousstatus/${id}`);
  },
  getHistory(certificationId) {
    return http.get(`${baseURL}/history/${certificationId}`);
  },
  deny(properties) {
    return http.post(`${baseURL}/deny`, properties);
  },
  approve(properties) {
    return http.post(`${baseURL}/approve`, properties);
  },
  changeToNotSubmitted(properties) {
    return http.post(`${baseURL}/setnotsubmitted`, properties);
  },
};
